import { message } from "antd";
import SystemsApi from "../api/SystemsApi";

export default {
    getSystems : async () => {
        return await SystemsApi.getSystems();
    },
    getMySystems : async () => {
        const response = await SystemsApi.getMySystems();
        if (!response.success){
            response.data = [];
            message.error("Error al cargar los sistemas");
        }
        return response;
    }
}   